import ReactDOM from 'react-dom'
import './index.css'
import { Signup } from './signup/Signup'

const app = document.getElementById('app')
ReactDOM.render(<Signup />, app)
